import L10n from "lib/carrot-l10n"
import Helpers from "utils/Helpers"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CarrotErrorCodes = {
  EMPLOYEE_INACTIVE: "MEMBER_INACTIVE",
  EMPLOYEE_ALREADY_REGISTERED: "EMPLOYEE_ALREADY_REGISTERED",
  EMPLOYEE_NOT_FOUND: "EMPLOYEE_NOT_FOUND",
  EMPLOYEE_NOT_SAML_ENABLED: "EMPLOYEE_NOT_SAML_ENABLED",
  EMPLOYEE_SAML_ENABLED: "EMPLOYEE_SAML_ENABLED",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  NOT_AUTHENTICATED: "NOT_AUTHENTICATED",
  SAML_COULD_NOT_FIND_PRINCIPAL_CLAIM: "SAML_COULD_NOT_FIND_PRINCIPAL_CLAIM",
  SAML_COULD_NOT_FIND_PRINCIPAL_IDENTITY: "SAML_COULD_NOT_FIND_PRINCIPAL_IDENTITY",
  SAML_ENTITY_ID_MISMATCH: "SAML_ENTITY_ID_MISMATCH",
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR",
  EMPLOYEE_ALREADY_HAS_EMAIL: "EMPLOYEE_ALREADY_HAS_EMAIL",
  MULTIPLE_EMPLOYEES_FOUND: "MULTIPLE_EMPLOYEES_FOUND"
}

const CARROT_ERROR_CODES_TO_MESSAGES = {
  [CarrotErrorCodes.EMPLOYEE_NOT_SAML_ENABLED]: l`client.accessDenied`,
  [CarrotErrorCodes.EMPLOYEE_ALREADY_REGISTERED]: l`client.signUp.employeeAlreadyRegistered`,
  [CarrotErrorCodes.EMPLOYEE_NOT_FOUND]: l`client.employeeNotFound`,
  [CarrotErrorCodes.EMPLOYEE_SAML_ENABLED]: l`client.signUp.employeeAlreadyRegistered`,
  [CarrotErrorCodes.INTERNAL_SERVER_ERROR]: l`client.internalServerError`,
  [CarrotErrorCodes.NOT_AUTHENTICATED]: l`client.notAuthenticated`,
  [CarrotErrorCodes.SAML_COULD_NOT_FIND_PRINCIPAL_CLAIM]: l`client.accessDenied`,
  [CarrotErrorCodes.SAML_COULD_NOT_FIND_PRINCIPAL_IDENTITY]: l`client.accessDenied`,
  [CarrotErrorCodes.SAML_ENTITY_ID_MISMATCH]: l`client.accessDenied`,
  [CarrotErrorCodes.UNEXPECTED_ERROR]: l`client.unexpectedError`,
  [CarrotErrorCodes.EMPLOYEE_INACTIVE]: l`client.employeeInactive`
}

const getErrorMessageFromCode = (errorCode) => {
  return Helpers.getFromMapOrReportAndDefault(
    CARROT_ERROR_CODES_TO_MESSAGES,
    errorCode,
    CarrotErrorCodes.UNEXPECTED_ERROR
  )
}

export { CarrotErrorCodes, getErrorMessageFromCode }
